// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__GPTNG","container__disabled":"Pagination_container__disabled__2ohL3"};